import { createFileRoute } from "@tanstack/react-router";
import { AktoerPage } from "@/features/bestillinger/pages/AktoerPage";

export const Route = createFileRoute("/_app/bestilling/ny/aktoer/")({
  component: AktoerPage,
  head: () => ({
    meta: [
      {
        title: "Velg aktør | Norgespris for Fjernvarme",
      },
    ],
  }),
});
